export default __webpack_public_path__ + "static/media/regulatory--cycling-restriction--g1.1b19c2a9.png";